/**
 * PositEmptyState.tsx
 * 
 * Empty state component displayed when no posits are found.
 * Extracted from MyPosits.tsx to improve modularity and reusability.
 */

import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface PositEmptyStateProps {
  hasFilters: boolean;
  clearFilters?: () => void;
  isOwner: boolean;
  isPremium: boolean;
}

const PositEmptyState: React.FC<PositEmptyStateProps> = ({
  hasFilters,
  clearFilters,
  isOwner,
  isPremium,
}) => {
  if (hasFilters) {
    return (
      <div className="text-center py-10">
        <h3 className="text-lg font-medium mb-2">No matching posits found</h3>
        <p className="text-muted-foreground mb-4">
          No posits match your current filters. Try adjusting your search criteria.
        </p>
        {clearFilters && (
          <Button variant="outline" onClick={clearFilters}>
            Clear All Filters
          </Button>
        )}
      </div>
    );
  }

  if (isOwner) {
    return (
      <div className="text-center py-10">
        <h3 className="text-lg font-medium mb-2">No posits yet</h3>
        <p className="text-muted-foreground mb-4">
          You haven't created any posits yet. Get started by creating your first posit!
        </p>
        <Link to="/create-posit">
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            Create Your First Posit
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="text-center py-10">
              <h3 className="text-lg font-medium mb-2">No public Posits available</h3>
      <p className="text-muted-foreground mb-4">
                  This user hasn't published any public Posits yet.
      </p>
      {!isPremium && (
        <Link to="/integrations">
          <Button variant="outline">
            Upgrade to Posit Plus
          </Button>
        </Link>
      )}
    </div>
  );
};

export default PositEmptyState; 